import { render, staticRenderFns } from "./MaintenanceHistoryTable.vue?vue&type=template&id=458907ba&scoped=true&"
import script from "./MaintenanceHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MaintenanceHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceHistoryTable.vue?vue&type=style&index=0&id=458907ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458907ba",
  null
  
)

export default component.exports